import { render, staticRenderFns } from "./kzList.vue?vue&type=template&id=c9419a1a&"
import script from "./kzList.vue?vue&type=script&lang=js&"
export * from "./kzList.vue?vue&type=script&lang=js&"
import style0 from "./kzList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "kzList.vue"
export default component.exports